import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Input as RsInput, Label, FormText, Col } from 'reactstrap';
import uuid from 'uuid/v4';
import Feedback from './Feedback';
import FormGroup from './FormGroup';
import Input from './Input';
var colSizes = ['xs', 'sm', 'md', 'lg', 'xl'];

var Field = function Field(_ref) {
  var helpMessage = _ref.helpMessage,
      label = _ref.label,
      labelHidden = _ref.labelHidden,
      inputClass = _ref.inputClass,
      labelClass = _ref.labelClass,
      id = _ref.name,
      size = _ref.size,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      grid = _ref.grid,
      labelAttrs = _ref.labelAttrs,
      groupAttrs = _ref.groupAttrs,
      attributes = _objectWithoutPropertiesLoose(_ref, ["helpMessage", "label", "labelHidden", "inputClass", "labelClass", "name", "size", "disabled", "readOnly", "grid", "labelAttrs", "groupAttrs"]);

  var row = false;
  var inputId = attributes.id || uuid();
  var col = {};
  var labelCol = {};

  if (grid) {
    colSizes.forEach(function (colSize) {
      if (grid[colSize]) {
        row = true;
        var sizeNum = parseInt(grid[colSize], 10);
        col[colSize] = sizeNum;
        labelCol[colSize] = 12 - sizeNum;
      }
    });
  }

  var input = React.createElement(Input, Object.assign({
    name: id,
    id: inputId,
    className: inputClass,
    size: size,
    disabled: disabled,
    readOnly: readOnly
  }, attributes));
  var help = helpMessage ? React.createElement(FormText, null, helpMessage) : null;
  var inputRow = row ? React.createElement(Col, col, input, React.createElement(Feedback, {
    name: id
  }), help) : input;
  var check = attributes.type === 'checkbox';
  return React.createElement(FormGroup, Object.assign({
    "for": id,
    check: check,
    disabled: disabled,
    row: row
  }, groupAttrs), check && inputRow, label && React.createElement(Label, Object.assign({
    "for": inputId,
    className: labelClass,
    hidden: labelHidden,
    size: size
  }, labelCol, labelAttrs), label), !check && inputRow, !row && React.createElement(Feedback, {
    name: id
  }), !row && help);
};

Field.defaultProps = {
  tag: RsInput
};
export default Field;